const TABLE_HEADERS = [
  'User ID', 
  'First name', 
  'Last Name', 
  'Email', 
  'Role', 
  '',
];
export default TABLE_HEADERS;
